const TOPIC_ITEMS = [
  { label: '天美影视高清', hot: true },
  { label: '免费在线观看', hot: true },
  { label: '最新电影推荐', hot: true },
  { label: '热播电视剧', hot: false },
  { label: '不缓冲不卡顿', hot: false },
  { label: '高分悬疑片', hot: true },
  { label: '国产古装剧', hot: false },
  { label: '科幻大片', hot: false },
  { label: '流畅追剧', hot: true },
  { label: '每日更新片源', hot: false },
  { label: '高清画质', hot: true },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-600">大家都在关注这些影视关键词</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPIC_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              {item.hot && (
                <i className="ri-fire-line text-accent-500 text-sm"></i>
              )}
              {item.label}
              {item.hot && (
                <span className="text-xs text-accent-600 font-normal">热</span>
              )}
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-foreground-500">
            以上话题标签基于天美影视平台用户搜索热度与观影趋势实时生成
          </p>
        </div>
      </div>
    </section>
  );
}